import {useEffect} from "react";

const useMediaSession = (isPlaying, currentStation, currentNowPlaying, updateMediaSessionMetadata) => {
	useEffect(() => {
		if (isPlaying) {
			updateMediaSessionMetadata(isPlaying, currentStation, currentNowPlaying);
		}
	}, [isPlaying, currentStation, currentNowPlaying]);
}

export default useMediaSession;